(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["traiteur-form"] && !Shopify.designMode) return;
  try {
    
(function(){
  // ========== CONFIGURATION FORMSPREE ==========
  var FORMSPREE_ENDPOINT = 'https://formspree.io/f/xnneovnz';

  // ========== ÉLÉMENTS DOM ==========
  var popup = document.getElementById('sensPopup');
  var openButtons = document.querySelectorAll('[data-open-form]');
  var closeTriggers = popup ? popup.querySelectorAll('[data-close-popup]') : [];
  var formCard = document.getElementById('formTraiteur');
  var startBtn = document.getElementById('startWizardBtn');
  var bottomBar = document.getElementById('sensBottomBar');
  var form = document.getElementById('sensWizard');
  var thankyou = document.getElementById('thankyou');
  
  if (!form) {
    console.error('❌ Formulaire sensWizard introuvable');
    return;
  }

  var steps = Array.from(form.querySelectorAll('fieldset'));
  var nextBtn = document.getElementById('nextBtn');
  var prevBtn = document.getElementById('prevBtn');
  var progressBar = document.getElementById('progressBar');
  var progressWrapper = document.querySelector('.sens-progress');
  var stepNote = document.getElementById('stepCount');
  var stepPercent = document.getElementById('stepPercent');
  
  var current = 0;
  var totalSteps = steps.length;

  // ========== FONCTION FERMETURE POPUP ==========
  function closePopup(){
    if(!popup) return;
    popup.classList.add('sens-hidden');
    popup.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('sens-no-scroll');
    document.body.classList.remove('sens-no-scroll');
  }

  // ========== FONCTION D'ENVOI EMAIL VIA FORMSPREE ==========
  function sendFormToFormspree() {
    var fd = new FormData(form);
    
    var formData = {
      _subject: '🔥 Nouvelle demande traiteur SENS',
      type_evenement: fd.get('type') || 'Non spécifié',
      nombre_convives: fd.get('people') || 'Non spécifié',
      format_service: fd.get('format') || 'Non spécifié',
      lieu: fd.get('lieu') || 'Non spécifié',
      date: fd.get('date') || 'Non spécifiée',
      budget: fd.get('budget') || 'Non défini',
      notes: fd.get('notes') || 'Aucune',
      nom: fd.get('nom') || 'Non fourni',
      email: fd.get('email') || 'Non fourni',
      telephone: fd.get('tel') || 'Non fourni'
    };
    
    console.log('📤 Envoi via Formspree...');
    
    return fetch(FORMSPREE_ENDPOINT, {
      method: 'POST',
      body: JSON.stringify(formData),
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      }
    })
    .then(function(response) {
      if (response.ok) {
        console.log('✅ Email envoyé avec succès!');
        form.classList.add('sens-hidden');
        if (thankyou) thankyou.classList.remove('sens-hidden');
        setTimeout(function() { closePopup(); }, 4000);
        return Promise.resolve();
      } else {
        return Promise.reject('Erreur serveur');
      }
    })
    .catch(function(error) {
      console.error('❌ Erreur:', error);
      return Promise.reject(error);
    });
  }

  // ========== GESTION BOTTOM BAR MOBILE ==========
  function handleBottomBarVisibility(){
    if(window.innerWidth <= 768 && bottomBar){
      var firstBlock = document.body.firstElementChild;
      if(firstBlock){
        var scrollY = window.scrollY || window.pageYOffset;
        if(scrollY >= firstBlock.offsetHeight){
          bottomBar.classList.remove('sens-hidden');
        }else{
          bottomBar.classList.add('sens-hidden');
        }
      }
    }
  }

  window.addEventListener('scroll', handleBottomBarVisibility);
  window.addEventListener('resize', handleBottomBarVisibility);
  handleBottomBarVisibility();

  // ========== GESTION BARRE DE PROGRESSION (CORRIGÉE) ==========
  function updateProgress(stepIndex){
    var pct = Math.round(((stepIndex + 1) / totalSteps) * 100);
    
    // Mise à jour de la barre visuelle
    if (progressBar) {
      progressBar.style.cssText = 'width: ' + pct + '% !important;';
      console.log('📊 Barre mise à jour:', pct + '%');
    }
    
    // Mise à jour du conteneur progressbar
    if (progressWrapper) {
      progressWrapper.setAttribute('aria-valuenow', pct);
    }
    
    // Mise à jour des indicateurs textuels
    if (stepNote) {
      stepNote.textContent = 'Étape ' + (stepIndex + 1) + ' sur ' + totalSteps;
    }
    if (stepPercent) {
      stepPercent.textContent = pct + '%';
    }
  }

  // ========== AFFICHAGE DES ÉTAPES ==========
  function showStep(i){
    steps.forEach(function(fs, idx) {
      if (idx === i) {
        fs.classList.remove('sens-hidden');
        fs.style.display = 'grid';
      } else {
        fs.classList.add('sens-hidden');
        fs.style.display = 'none';
      }
    });
    
    current = i;
    
    if (prevBtn) prevBtn.disabled = (i === 0);
    if (nextBtn) nextBtn.textContent = (i === totalSteps - 1) ? "Envoyer" : "Suivant →";
    
    // Mettre à jour la progression
    updateProgress(i);
  }

  // ========== RÉINITIALISATION DU WIZARD ==========
  function resetWizard(){
    current = 0;
    
    steps.forEach(function(fs, idx) {
      if (idx === 0) {
        fs.classList.remove('sens-hidden');
        fs.style.display = 'grid';
      } else {
        fs.classList.add('sens-hidden');
        fs.style.display = 'none';
      }
      
      fs.querySelectorAll('input, textarea').forEach(function(input) {
        if(input.type === 'radio' || input.type === 'checkbox') {
          input.checked = false;
        } else {
          input.value = "";
        }
      });
    });
    
    if(prevBtn) prevBtn.disabled = true;
    if(nextBtn) {
      nextBtn.disabled = false;
      nextBtn.textContent = "Suivant →";
    }
    
    if(thankyou){
      thankyou.classList.add('sens-hidden');
      form.classList.remove('sens-hidden');
    }
    
    // Réinitialiser la barre de progression
    if(progressBar) progressBar.style.cssText = 'width: 0% !important;';
    if(stepNote) stepNote.textContent = 'Étape 1 sur ' + totalSteps;
    if(stepPercent) stepPercent.textContent = '0%';
  }

  // ========== OUVERTURE DU POPUP ==========
  function openPopup(){
    if(!popup) return;
    
    popup.classList.remove('sens-hidden');
    popup.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('sens-no-scroll');
    document.body.classList.add('sens-no-scroll');
    
    if(formCard) formCard.classList.add('sens-intro-active');
    resetWizard();
    if(startBtn) startBtn.focus();
  }

  // ========== EVENT LISTENERS OUVERTURE ==========
  openButtons.forEach(function(btn) {
    btn.addEventListener('click', function(e){
      if(this.tagName.toLowerCase() === 'a') e.preventDefault();
      openPopup();
    });
  });

  // ========== EVENT LISTENERS FERMETURE ==========
  closeTriggers.forEach(function(el) {
    el.addEventListener('click', closePopup);
  });
  
  document.addEventListener('keydown', function(e) {
    if(e.key === 'Escape') closePopup();
  });

  // ========== DÉMARRAGE DU WIZARD ==========
  if(startBtn){
    startBtn.addEventListener('click', function() {
      if(formCard) formCard.classList.remove('sens-intro-active');
      current = 0;
      showStep(0);
      
      var firstRequired = steps[0].querySelector('[required]');
      if(firstRequired) firstRequired.focus();
    });
  }

  // ========== VALIDATION D'ÉTAPE ==========
  function stepValid(i){
    var fs = steps[i];
    var allRequired = Array.from(fs.querySelectorAll('[required]'));
    
    return allRequired.every(function(el) {
      if (el.type === 'radio'){
        var radioGroup = Array.from(fs.querySelectorAll('input[name="' + el.name + '"]'));
        return radioGroup.some(function(r) { return r.checked; });
      }
      return el.value.trim() !== "";
    });
  }

  // ========== BOUTON SUIVANT ==========
  if (nextBtn){
    nextBtn.addEventListener('click', function() {
      if(!stepValid(current)){
        var fs = steps[current];
        fs.style.outline = '2px solid #FF5E3A';
        setTimeout(function() { fs.style.outline = 'none'; }, 600);
        
        var firstReq = fs.querySelector('[required]');
        if(firstReq) firstReq.focus();
        return;
      }

      if(current < totalSteps - 1){
        current++;
        showStep(current);
      } else {
        nextBtn.disabled = true;
        nextBtn.textContent = 'Envoi…';
        
        sendFormToFormspree()
          .catch(function(error) {
            alert("Oups, l'envoi a échoué. Vous pouvez nous écrire à contact@sensnutrition.eu");
            nextBtn.disabled = false;
            nextBtn.textContent = 'Envoyer';
          });
      }
    });
  }

  // ========== BOUTON PRÉCÉDENT ==========
  if (prevBtn){
    prevBtn.addEventListener('click', function() {
      if(current > 0){
        current--;
        showStep(current);
      }
    });
  }

  // ========== TOUCHE ENTRÉE ==========
  form.addEventListener('keydown', function(e) {
    if(e.key === 'Enter' && e.target.tagName.toLowerCase() !== 'textarea'){
      e.preventDefault();
      if (nextBtn) nextBtn.click();
    }
  });

  console.log('✅ Formulaire SENS initialisé (Formspree) -', totalSteps, 'étapes');

})();

  } catch(e) { console.error(e); }
})();
})();
